/** @format */

import React from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from 'react-google-maps';

const greyScaleStyle = [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#e7e7e7' }]
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [{ color: '#cf6584' }]
  },
  {
    elementType: 'geometry',
    stylers: [{ saturation: -60 }]
  },
  {
    elementType: 'labels',
    stylers: [{ visibility: 'on' }]
  }
];

const MapComponent = withScriptjs(
  withGoogleMap(({ latitude, longitude, zoomLevel = 8 }) => (
    <GoogleMap
      zoom={zoomLevel}
      defaultZoom={8}
      defaultCenter={{ lat: latitude, lng: longitude }}
      options={{
        styles: greyScaleStyle
      }}>
      <Marker position={{ lat: latitude, lng: longitude }} />
    </GoogleMap>
  ))
);

export default MapComponent;
